import { authenticatedProApiFetch } from "./pro-api.client";

export type BrowserErrorReport = {
  message: string;
  name?: string;
  stack?: string;
  componentStack?: string;
  route?: string;
  url?: string;
  userAgent?: string;
};

export async function reportBrowserError(
  accessToken: string,
  report: BrowserErrorReport,
): Promise<void> {
  await authenticatedProApiFetch("/users/me/browser-errors", accessToken, {
    method: "POST",
    body: JSON.stringify(report),
  });
}
